import cx from 'classnames';

var _this = void 0;

var _classnames = _interopRequireDefault(cx);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError('Cannot instantiate an arrow function');
  }
}

const capitalize = function capitalize(s) {
  _newArrowCheck(this, _this);

  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}.bind(void 0);

const camelCase = function camelCase(str) {
  var _this3 = this;

  _newArrowCheck(this, _this);

  return str.replace(
    /([-_][a-z])/g,
    function(group) {
      _newArrowCheck(this, _this3);

      return group
        .toUpperCase()
        .replace('-', '')
        .replace('_', '');
    }.bind(this)
  );
}.bind(void 0);

const mergeProps = function mergeProps(reactInstanceProps, defaultProps) {
  _newArrowCheck(this, _this);

  let { className, id, style } = reactInstanceProps,
    remainingProps = _objectWithoutProperties(reactInstanceProps, ['className', 'id', 'style']);

  let { className: defaultClassName, id: defaultId, style: defaultStyle = {} } = defaultProps,
    remainingDefaultProps = _objectWithoutProperties(defaultProps, ['className', 'id', 'style']);

  className = (0, _classnames.default)(defaultClassName, className);
  style = _objectSpread({}, defaultStyle, {}, style);
  id = id || defaultId;
  remainingProps = _objectSpread({}, remainingDefaultProps, {}, remainingProps);
  return _objectSpread(
    {
      className,
      id,
      style,
    },
    remainingProps
  );
}.bind(void 0);

export { capitalize, camelCase, mergeProps };
